import React from 'react';
import Section from '../components/Section';
import DropdownField from '../components/DropdownField';
import TextField from '../components/TextField';

const SHIFT_OPTIONS = [
  '🟢 Good shift — no major issues',
  '🟡 Okay — a few things to flag',
  '🔴 Tough shift — significant issues',
];

const CUSTOMER_COUNT_OPTIONS = [
  'Under 20',
  '20–40',
  '40–60',
  '60–80',
  'Over 80',
];

const PEAK_HOUR_OPTIONS = [
  '11am–12pm',
  '12–1pm',
  '1–2pm',
  '2–3pm',
  '3–4pm',
  '4–5pm',
  '5–6pm',
  '6–7pm',
  '7–8pm',
  '8–9pm',
  '9–10pm',
  '10–11pm',
];

function S1_OverallShift({ data, onChange, errors }) {
  return (
    <Section title="How did today go?">
      <DropdownField
        label="How did today go overall?"
        options={SHIFT_OPTIONS}
        value={data.shift_overall}
        onChange={(v) => onChange('shift_overall', v)}
        required
        hasError={!!errors.shift_overall}
        errorMsg={errors.shift_overall}
        placeholder="Select…"
      />

      {/* NEW — Bills today (mandatory) */}
      <TextField
        label="Bills today"
        type="number"
        value={data.bills_today ?? ''}
        onChange={(v) => onChange('bills_today', v === '' ? '' : Number(v))}
        required
        hasError={!!errors.bills_today}
        errorMsg={errors.bills_today}
        placeholder="e.g. 34"
      />

      {/* NEW — Peak hour (mandatory) */}
      <DropdownField
        label="Peak hour today"
        options={PEAK_HOUR_OPTIONS}
        value={data.peak_hour || ''}
        onChange={(v) => onChange('peak_hour', v)}
        required
        hasError={!!errors.peak_hour}
        errorMsg={errors.peak_hour}
        placeholder="Select…"
      />

      <DropdownField
        label="Roughly how many customers today?"
        options={CUSTOMER_COUNT_OPTIONS}
        value={data.customer_count}
        onChange={(v) => onChange('customer_count', v)}
        placeholder="Select (optional)"
      />
    </Section>
  );
}

export default S1_OverallShift;
